import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { StructureOrganizative, ToastrService, AuthService, CacheService } from "mapfre-auditlib";
import { Observable, forkJoin, throwError, Subscription, interval, takeWhile, EMPTY, lastValueFrom, take, of } from "rxjs";
import { map, mergeMap, catchError, switchMap, startWith, skipWhile } from "rxjs/operators";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import * as FileSaver from 'file-saver';

@Injectable({
   providedIn: "root"
})
export class TimeAllocationService {

   className = 'TimeAllocationService';

   constructor(private http: HttpClient, private translateService: TranslateService, private toastService: ToastrService, private authService: AuthService, private cacheService: CacheService) { }

   getAll(cache = true, cacheKey = "allAllocationTimeStateNodes"): Observable<any[]> | any {
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<any[]>(environment.base_URL + "/types-state-nodes/").pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }
   getImpDateByDate(userId, startDate, endDate): Observable<any[]> { // alterar esta llamada para obtener mrkActive y poder hacer que no pasen a la siguiente semana
      let params: any = {};
      if (startDate) {
         params.startDate = startDate;
      }
      if (endDate) {
         params.finishDate = endDate;
      }
      return this.http.get<any[]>(environment.base_URL + `/imputation-times/user/${userId}`, { params }).pipe(map(result => {

         _.forEach(result, item => {
            item.txtTypeConceptImputation = item.imputationConcept;
            item.txtTypeSubconceptImputation = item.imputationSubConcept;
         });

         let final = [];

         let groupBy = _.chain(result)
            .groupBy(x => x.typeConceptImputationId)
            .map((value, key) => value)
            .value();

         let tempArray = [];
         _.forEach(groupBy, (group: any) => {
            let groupTemp = _.chain(group)
               .groupBy(x => x.txtComment)
               .map((value, key) => value)
               .value();               
               tempArray.push(groupTemp);
               
         });

         groupBy = _.flatten(tempArray);

         _.forEach(groupBy, (group: any) => {
            let groupTemp = _.chain(group)
               .groupBy(x => x.jobId ? x.jobId : x.paiId)
               .map((value, key) => value)
               .value();
            let array = [];
            _.forEach(groupTemp, groupItemTemp => {
               let groupByDays = _.chain(groupItemTemp)
                  .groupBy(x => x.dateImputation)
                  .map((value, key) => value)
                  .value();

               for (let index = 0; index < groupByDays[0].length; index++) {
                  let arrayTemp = [];
                  _.forEach(groupByDays, (days, i) => {
                     if (_.get(days, index)) {
                        arrayTemp.push(_.get(days, index));
                     }
                  })
                  array.push(arrayTemp);
               }
            });

            groupTemp = array;

            _.forEach(groupTemp, groupItemTemp => {
               const fatherTemp = _.cloneDeep(groupItemTemp[0]);
               _.forEach(groupItemTemp, it => it.init = true);
               fatherTemp.imputationTime = groupItemTemp;

               final.push(fatherTemp);
            })

         })


         return _.orderBy(final, 'idImputationPk', 'asc');
      }));
   }

   getImpDaysByDate(userId, filtersBack) {

      let params: any = {};
      if (filtersBack) {
         params = filtersBack;
      }

      return this.http.get<any[]>(environment.base_URL + `/imputation-times/user/${userId}`, { params });
   }

   newImpDate(allocation) {
      return this.http.post(environment.base_URL + "/imputation-times", allocation);
   }

   getSummary(userId, cache = true, cacheKey = "timeSummary"): Observable<any[]> | any {
      cacheKey = cacheKey+"_"+userId.toString()
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<any[]>(environment.base_URL + `/imputation-times/user/${userId}/info`).pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
      
   }

   getActivitesBySO(structureId, cache = true, cacheKey = "activitiesBySO"): Observable<any[]> | any {
      cacheKey = cacheKey+"_"+structureId.toString()
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
       } else {
         let observable = this.http.get<any[]>(environment.base_URL + `/imputation-times/activities/os/${structureId}`).pipe(map((res) => {
         this.cacheService.updateCacheData(res, cacheKey)
         return res;
         }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
       }
   }

   /**
 * Export jobs
 * @param key 
 * @param params 
 */
   exportImputation(key, params) {

      const user_locale = window.navigator.language;
      _.set(params, "locale", user_locale);

      // Set key file in parameters
      _.set(params, "key", key + '/data.json');

      this.toastService.add({ severity: "info", summary: this.translateService.instant("TOAST.GENERAL.INFO_LOADING_TITLE"), detail: this.translateService.instant("TOAST.GENERAL.INFO_EXPORT"), life: 240000 });

      if (!params.finishDate) {
         params.finishDate = moment(new Date(new Date().getFullYear(), 11, 31)).format('YYYY-MM-DD');
      }

      if (!params.startDate) {
         params.startDate = moment(new Date(new Date().getFullYear(), 0, 1)).format('YYYY-MM-DD')
      }

      // Call aws gateway to generate pre signed url
      return this.http.get<any[]>(environment.base_URL + "/exported-url", { params })
         .pipe(mergeMap((res: any) => {

            // Remove key paramenter and add url parameter
            _.unset(params, "key")
            _.set(params, "url", res)

            // Call Mapgre Gateway to generate excel with exoprted jobs
            return this.http.get<any[]>(environment.base_URL + "/exported-imputations", { params })
               .pipe(mergeMap((res: any) => {

                  // Remove url paramenter and add key parameter
                  let paramsExcel = {}
                  _.set(paramsExcel, "keydata", key + '/data.json');
                  _.set(paramsExcel, "keyexcel", key + '/export.xlsx');

                  return this.http.get<any[]>(environment.base_URL + "/create-excel", { params: paramsExcel })
                     .pipe(mergeMap((res3: any) => {

                        // Remove url paramenter and add key parameter
                        let paramsDownload = {}
                        _.set(paramsDownload, "onlyDownload", true)

                        let body = {
                           key: key + '/export.xlsx'
                        }

                        // Download excel
                        return this.http.post(environment.base_URL + `/download`, body, { params: paramsDownload })
                           .pipe(mergeMap((res: any) => {

                              // Download file
                              let options = {
                                 responseType: "blob" as 'json'
                              }

                              // Download file form S3
                              return this.http.get(res, options);

                           }), map(res => {

                              //Clear toast notification
                              this.toastService.clear()
                              //Download generated Excel
                              FileSaver.saveAs(res, `export.xlsx`);

                              // Delete file when downloaded
                              this.delete(key).subscribe(() => { });
                              return res;

                           }), catchError(err => {
                              this.toastService.add({
                                 severity: "error",
                                 summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                                 detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
                              });
                              return throwError(err);
                           }))
                     }))
               }))

         }), map(res => {
            return res;
         }), catchError<Observable<any>, any>((err) => {

            if(err.status != 500 && err.status != 404){ 

               let target = {};
               _.set(target, "keyFile", key + '/data.json');

               let ob: Observable<any>;
               let cont = 0;

               //Condiciones de timeout y repetición de request a check-files
               function checkConditions(response){
                  if(cont <18 && response.statusCode === 404){
                     cont++;
                     return true;
                  }else{
                     cont++;
                     return false
                  }
               }

               //Multiple request to lambda chech-files. Stops when file has been found or timeout
               ob = interval(5000)
               .pipe(
               startWith(0),
               switchMap(() => this.http.get<any>(environment.base_URL + "/check-files", { params: target })),
               takeWhile(response => checkConditions(response), true)
               )

               forkJoin([ob]).subscribe(([check]) => {

                  if(check.statusCode === 200){

                     let paramsExcel = {}
                     _.set(paramsExcel, "keydata", key + '/data.json');
                     _.set(paramsExcel, "keyexcel", key + '/export.xlsx');

                     let result = forkJoin( [this.http.get<any[]>(environment.base_URL + "/create-excel", { params: paramsExcel })])

                     return forkJoin([result]).subscribe(([resul1]) => {

                        // Remove url paramenter and add key parameter
                        let paramsDownload = {}
                        _.set(paramsDownload, "onlyDownload", true)

                        let body = {
                           key: key + '/export.xlsx'
                        }

                        // Download excel
                        let result2 = this.http.post(environment.base_URL + `/download`, body, { params: paramsDownload })
                           .pipe(mergeMap((res: any) => {
                              // Download file
                              let options = {
                                 responseType: "blob" as 'json'
                              }

                              //Clear toast notification
                              this.toastService.clear()

                              // Download file form S3
                              return this.http.get(res, options);

                           }), map(res => {

                              // Delete file when downloaded
                              this.delete(key).subscribe(() => { });
                              return res;

                           }), catchError(err => {
                              this.toastService.add({
                                 severity: "error",
                                 summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                                 detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
                              });
                              return throwError(err);
                           }))

                           return forkJoin([result2]).subscribe(([resul2]) => {
                              //Download generated Excel
                              FileSaver.saveAs(resul2, `export.xlsx`);
                              return resul2;
                           });
                     });
                  }else{
                     //Clear toast info notification
                     this.toastService.clear()

                     this.toastService.add({
                        severity: "error",
                        summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
                        detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TIMEOUT"), life: 5000
                     });
                  }
            });
            }else{
               //Clear toast info notification
               setTimeout(() => {
                  this.toastService.clear()
               },4000)
            }
         return EMPTY;
         }))
   }


   delete(key): any {
      let params = {
         key
      }
      return this.http.post(environment.base_URL + "/delete", { params }).pipe(catchError(err => {
         this.toastService.add({
            severity: "error",
            summary: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_TITLE"),
            detail: this.translateService.instant("TOAST.GENERAL.ERROR_FILE_DETAIL"), life: 5000
         });
         return throwError(err);
      }));
   }

}
